module.exports = __webpack_public_path__ + "img/bing1.d71a3b1e.png";